import { lazy } from 'react'

export const FamilySafetyVariant1 = lazy(() => import('./FamilySafetyVariant1'))
